import React, { useState, useContext } from 'react';
import { Card, Table, NavDropdown } from 'react-bootstrap';
import { useWidgetContext } from '../context/DragContext';
import { AuthContext } from '../context/AuthContext';
import Skeleton from 'react-loading-skeleton';
import SwitchAccount from '../common/SwitchAccount';

function Holdings() {
  const [showDropdown, setShowDropdown] = useState(false);
  const { removeWidgetFromGrid } = useWidgetContext();
  const { yourHoldingData, accountInfoData, holdingsLoading, userData } = useContext(AuthContext);
  const [switchAccount, setSwitchAccount] = useState(false);

  const accruedCashAmount = accountInfoData?.summary?.netLiquidationValue|| 0;
  // console.log(accruedCashAmount);
  
  const handleOpenSwitchAccount = () => setSwitchAccount(true);
  const handleCloseSwitchAccount = () => setSwitchAccount(false);

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };

  const handleSvgClick = () => {
    setShowDropdown(!showDropdown);
  };

  // function formatExpiryDate(expiry) {
  //   if (!expiry || expiry.length !== 8) {
  //     // Return an error message or a fallback value if input is invalid
  //     // console.error("Invalid expiry date format");
  //     return "N/A";
  //   }
  
  //   // Parse the year, month, and day from the string
  //   const year = expiry.slice(0, 4);
  //   const month = expiry.slice(4, 6) - 1; // Months are zero-indexed in JavaScript Date
  //   const day = expiry.slice(6, 8);
  
  //   // Create a new Date object
  //   const date = new Date(year, month, day);
  
  //   // Format the date using Intl.DateTimeFormat
  //   const formattedDate = new Intl.DateTimeFormat('en-US', {
  //     month: 'short',
  //     day: '2-digit',
  //     year: 'numeric',
  //   }).format(date);
  
  //   return formattedDate;
  // }

  return (
    <>
      <Card className={`main-card mt-3 ${userData?.added_integrations?.length === 0 ? 'blur-card' : ''}`}>
        {userData?.added_integrations?.length === 0 && (
          <div className="blur-overlay">
            <img
              src={`${process.env.PUBLIC_URL}/images/lock-icon.svg`}
              alt="Lock Icon"
              style={{ height: '20px', width: '16px' }}
              className="lock-icon"
            />
            {userData?.added_integrations?.length === 0 && <button className="subscribe-button" onClick={handleOpenSwitchAccount}>Click to add Provider</button>}
          </div>
        )}
        <Card.Header className="pb-0">
          <div className="d-flex justify-content-between mt-1">
            <h2 className="medium-heading mb-0">Your holdings</h2>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                onClick={handleSvgClick}
                style={{ cursor: 'pointer' }}
              >
                <path d="M12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5006 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5006 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5Z" fill="white" />
                <path d="M18.75 13.5C18.4533 13.5 18.1633 13.412 17.9166 13.2472C17.67 13.0824 17.4777 12.8481 17.3642 12.574C17.2506 12.2999 17.2209 11.9983 17.2788 11.7074C17.3367 11.4164 17.4796 11.1491 17.6893 10.9393C17.8991 10.7296 18.1664 10.5867 18.4574 10.5288C18.7483 10.4709 19.0499 10.5006 19.324 10.6142C19.5981 10.7277 19.8324 10.92 19.9972 11.1666C20.162 11.4133 20.25 11.7033 20.25 12C20.25 12.3978 20.092 12.7794 19.8107 13.0607C19.5294 13.342 19.1478 13.5 18.75 13.5Z" fill="white" />
                <path d="M5.25 13.5C4.95333 13.5 4.66332 13.412 4.41665 13.2472C4.16997 13.0824 3.97771 12.8481 3.86418 12.574C3.75065 12.2999 3.72094 11.9983 3.77882 11.7074C3.8367 11.4164 3.97956 11.1491 4.18934 10.9393C4.39912 10.7296 4.66639 10.5867 4.95737 10.5288C5.24834 10.4709 5.54994 10.5006 5.82403 10.6142C6.09812 10.7277 6.33238 10.92 6.49721 11.1666C6.66203 11.4133 6.75 11.7033 6.75 12C6.75 12.3978 6.59197 12.7794 6.31066 13.0607C6.02936 13.342 5.64783 13.5 5.25 13.5Z" fill="white" />
              </svg>
              <NavDropdown
                show={showDropdown}
                onToggle={handleToggle}
                title=""
                id="nav-dropdown"
                align="end"
                className="d-inline custom-nav-dropdown"
                style={{ display: showDropdown ? 'block' : 'none' }}
              >
                <NavDropdown.Item className="dropdown-option" onClick={() => removeWidgetFromGrid('holdings')}>Close Window</NavDropdown.Item>
              </NavDropdown>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="pt-0 p-2 mt-3">
          <div className="table-responsive scrollbar-custom plr-2 w-t-div">
            <Table hover className="watchlist-table">
              <thead>
                <tr>
                  <th className="gray-text">Name</th>
                  <th className="text-end gray-text">Quantity</th>
                  <th className="text-end gray-text">Price</th>
                  <th className="text-end gray-text">Value</th>
                  <th className="text-end gray-text">P/L</th>
                  <th className="text-end gray-text">P/L %</th>
                  {/* <th className="text-end gray-text">Intraday P/L</th>
                  <th className="text-end gray-text">Intraday P/L %</th> */}
                </tr>
              </thead>
              <tbody>
                {holdingsLoading || !userData ? (
                  <tr>
                    <td colSpan={8}>
                      <Skeleton
                        count={3}
                        style={{ margin: '4px 2px', borderRadius: '3px' }}
                        baseColor="rgba(137, 136, 137, 0.3)"
                        highlightColor="rgba(176, 176, 176, 0.3)"
                      />
                    </td>
                  </tr>
                  ):(userData?.added_integrations?.length ?? 0) === 0 ? (
                    <>
                      <tr>
                        <td>GCQ4 <br /><span className="small-gray">05 July 2024</span></td>
                        <td className="text-end align-middle">310.32</td>
                        <td className="text-end align-middle">716.3</td>
                        <td className="text-end align-middle">222,282.2</td>
                        <td className="text-success text-end align-middle">15.2</td>
                        <td className="text-success text-end align-middle">0.65%</td>
                        {/* <td className="text-success text-end align-middle">34.1</td>
                        <td className="text-success text-end align-middle">1.46%</td> */}
                      </tr>
                      <tr>
                        <td>CLQ4 <br /><span className="small-gray">05 Aug 2024</span></td>
                        <td className="text-end align-middle">378.19</td>
                        <td className="text-end align-middle">54.28</td>
                        <td className="text-end align-middle">20,528.15</td>
                        <td className="text-danger text-end align-middle">-27.2</td>
                        <td className="text-danger text-end align-middle">-3.27%</td>
                        {/* <td className="text-danger text-end align-middle">-15.3</td>
                        <td className="text-danger text-end align-middle">-2.21%</td> */}
                      </tr>
                      <tr >
                        <td>ZSN4 <br /><span className="small-gray">05 Aug 2024</span></td>
                        <td className="text-end align-middle">27.32</td>
                        <td className="text-end align-middle">229.9</td>
                        <td className="text-end align-middle">6,280.87</td>
                        <td className="text-success text-end align-middle">7.1</td>
                        <td className="text-success text-end align-middle">0.33%</td>
                        {/* <td className="text-danger text-end align-middle">-26.5</td>
                        <td className="text-danger text-end align-middle">-7.10%</td> */}
                      </tr>
                      <tr>
                        <td>GCQ4 <br /><span className="small-gray">05 July 2024</span></td>
                        <td className="text-end align-middle">310.32</td>
                        <td className="text-end align-middle">716.3</td>
                        <td className="text-end align-middle">222,282.2</td>
                        <td className="text-success text-end align-middle">15.2</td>
                        <td className="text-success text-end align-middle">0.65%</td>
                        {/* <td className="text-success text-end align-middle">34.1</td>
                        <td className="text-success text-end align-middle">1.46%</td> */}
                      </tr>
                      <tr>
                        <td>CLQ4 <br /><span className="small-gray">05 Aug 2024</span></td>
                        <td className="text-end align-middle">378.19</td>
                        <td className="text-end align-middle">54.28</td>
                        <td className="text-end align-middle">20,528.15</td>
                        <td className="text-danger text-end align-middle">-27.2</td>
                        <td className="text-danger text-end align-middle">-3.27%</td>
                        {/* <td className="text-danger text-end align-middle">-15.3</td>
                        <td className="text-danger text-end align-middle">-2.21%</td> */}
                      </tr>
                    </>
                  ) : yourHoldingData && yourHoldingData.length > 0 ? (
                  yourHoldingData.map((holdings, index) => {
                    return (
                      <tr key={index}>
                        {/* <td>{holdings.description} <br /><span className="small-gray">{formatExpiryDate(holdings.expiry)}</span></td> */}
                        <td>{holdings.description} <br /><span className="small-gray">-</span></td>
                        <td className="text-end align-middle">{holdings?.position?.toFixed(2)}</td>
                        <td className="text-end align-middle">{holdings?.avgPrice?.toFixed(2) || 'N/A'}</td>
                        <td className="text-end align-middle">{holdings?.marketValue?.toFixed(2) || 'N/A'}</td>
                        <td className={`text-end align-middle ${ holdings?.realizedPnl > 0 ? 'text-success' : 'text-danger'}`}>{holdings?.realizedPnl?.toFixed(2) || 'N/A'}</td>
                        <td
                          className={`text-end align-middle ${
                            isFinite(holdings.realizedPnl / accruedCashAmount) && (holdings?.realizedPnl / accruedCashAmount) * 100 > 0
                              ? 'text-success'
                              : 'text-danger'
                          }`}
                        >
                          {isFinite(holdings.realizedPnl / accruedCashAmount)
                            ? Math.max(((holdings.realizedPnl / accruedCashAmount) * 100).toFixed(2), 0)
                            : 0}%
                        </td>

                        {/* <td className={`text-end align-middle`}>-</td>
                        <td className={`text-end align-middle`}>-</td> */}
                      </tr>
                    )})
                  ):(
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center", verticalAlign: "middle" }}>No data available</td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
      
      <SwitchAccount open={switchAccount} onClose={handleCloseSwitchAccount}/>
    </>
  );
}

export default Holdings;
